<template lang="html">
  <div>
    <section class="content-header">
      <h1>
        <span :class="$route.meta.icon"></span> {{ $route.meta.label }}
        <small></small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#/"> <i class="fa fa-home"></i> Início </a>
        </li>
        <li
          v-for="(breadcrumb, idx) in breadcrumbs"
          :key="idx"
          :class="{ active: idx === breadcrumbs.length - 1 }"
          v-if="!mainPath"
        >
          <a :href="`#${breadcrumb.path}`">
            {{ breadcrumb.label }}
          </a>
        </li>
      </ol>
    </section>
  </div>
</template>

<script>
export default {
  name: 'page-header',
  data() {
    return {
      breadcrumbs: []
    }
  },
  mounted() {
    this.mapBreadcrumbs()
  },
  methods: {
    mapBreadcrumbs() {
      this.breadcrumbs = this.$route.matched.map(match => {
        const { icon, label } = match.meta
        return {
          icon,
          label,
          path: match.path
        }
      })
    }
  },
  computed: {
    mainPath() {
      return this.$route.path === '/'
    }
  },
  watch: {
    $route() {
      this.mapBreadcrumbs()
    }
  }
}
</script>

<style lang="css"></style>
